module.exports = __webpack_public_path__ + "img/big-screen-h5-clean.a4157e23.png";